import request from '@/utils/puhui-request';

/**
 * 获取首页轮播
 */
export function getBanners() {
  return request({
    url: '/api/getAd',
    method: 'get',
  });
}

/**
 * 获取广西景点门票-旅发集团首页接口
 */
export function getParInfo(params) {
  return request({
    url: '/api/getParInfo',
    method: 'get',
    params
  });
}

